import React, { useState, useEffect } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import 'react-material-symbols/rounded';
import AxiosClient from '../../assets/AxiosClient';
import CitiesInIraq from "../../Forms/Data/CitiesInIraq"
import Countries from '../../Forms/Data/Countries';
const standardizeCity = (country, city) => {
  if (country === "Iraq") {
    return city;
  } else {
    const countryObj = Countries.find(c => c.name === country);
    if (countryObj) {
      return countryObj.Capital;
    } else {
      return null; // Country not found in the Countries array
    }
  }
};

const Cities = () => {
  const [Attendants, setAttendants] = useState([]);
  const [updatedIndexes, setUpdatedIndexes] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (Attendants.length === 0) {
      GetAttend();
    }
  }, []);

  const GetAttend = () => {
    AxiosClient.get('ETL/Attends').then((response) => {
      setAttendants(response.data);
    });
  };

  const Transfair = () => {
    const updatedAttendants = Attendants.map(attendant => {
      return {
        ...attendant,
        city: standardizeCity(attendant.country, attendant.city)
      };
    });
    setAttendants(updatedAttendants);
  };

  const Load = () => {
    const updatedIndexes = [];
    Attendants.forEach((attendant, index) => {
      AxiosClient.put(`ETL/CityUpdate/${attendant.id}`, {
        city: attendant.city // Pass the new city value in the request body
      }).then(response => {
        updatedIndexes.push(index);
        setUpdatedIndexes(updatedIndexes);
        const newProgress = ((updatedIndexes.length / Attendants.length) * 100).toFixed(2);
        setProgress(newProgress);
        // Handle success
        console.log(`City updated successfully for attendant ${attendant.id}`);
      }).catch(error => {
        console.error('Error updating attendee:', error);
      });
    });
  };

  const ShowNames = () => {
    // Implement the logic to show the names
    // You can access the names in the `Attendants` state
    // and display them in the table
  };

  return (
    <div className="row border-top">
      <div className="col-12">
        <div className="card my-4">
          <div className="card-body px-0 pb-2">
            <div className=" p-3">
              {Attendants.length === 0 && (
                <button className="btn btn-dark m-2" onClick={GetAttend}>
                  Extract <MaterialSymbol icon="chip_extraction" size={15} className="ml-2" />
                </button>
              )}
              {Attendants.length > 0 && (
                <>
                  <button className="btn btn-danger m-2" onClick={ShowNames}>
                    <MaterialSymbol icon="ent" size={15} className="ml-2" />
                    Show
                  </button>
                  <button className="btn btn-dark m-2" onClick={Transfair}>
                  <MaterialSymbol icon="ent" size={15} className="ml-2" />

                  Transfer </button>
                  <button className="btn btn-info m-2" onClick={Load}>
                  <MaterialSymbol icon="ent" size={15} className="ml-2" />

Load</button>
                </>
              )}
            </div>
            {Attendants.length > 0 && (
              <div>
                <div className="progress mb-3">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
                <table className="table">
                  <thead>
                    <tr>
                      <th> Name</th>
                      <th>Country</th>
                      <th>City</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Attendants.map((attendant, index) => (
                      <tr key={attendant.id} style={{ background: updatedIndexes.includes(index) ? 'lightgreen' : '' }}>
                        <td style={{ background: attendant.country !== "Iraq" && CitiesInIraq.includes(attendant.city) ? 'orange' : '' }}>
                       { attendant.first_name + " " +  attendant.last_name} 
                        </td>
                        <td style={{ background: attendant.country !== "Iraq" && CitiesInIraq.includes(attendant.city) ? 'orange' : '' }}>
                        { attendant.country} 
                        </td>
                        <td style={{ background: attendant.country !== "Iraq" && CitiesInIraq.includes(attendant.city) ? 'orange' : '' }}>
  {attendant.city}
</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cities;
